module.exports = __webpack_public_path__ + "img/Kasberget_infotaulu_kalliolla_Lasse_Nurmi_800px.903e4c4e.jpg";